import React, { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import RadioGroup, { Radio } from '../../../../../../components/RadioGroup';
import {
  ButtonCancel,
  ButtonContainer,
  ButtonInactivate,
  Container,
  Description,
  SuccessText,
  SuccessCircleIcon
} from './styles';
import { TextField } from 'material-ui';
import DynamicAPI from '../../../../../../shared/axios';
import CircularProgress from '@mui/material/CircularProgress';

const InactivateReceiptStatusModal = ({ data, onBackdropClick, setInactive }) => {
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [reasonText, setReasonText] = useState('');
  const [loading, setLoading] = useState(false);
  const [successRequest, setSuccessRequest] = useState(false);

  const reasonForInactivation = {
    PHOTO_DOES_NOT_MATCH: "Foto não corresponde à Nota Fiscal",
    PHOTO_IS_NOT_SHARP: "Foto não está nítida",
  };

  function onChangeReasonTextField(e) {
    setReasonText(e.target.value.trim());
  }

  async function handleInactivate() {
    setLoading(true);
    const params = {
      justification: `${selectedRadio}${reasonText !== '' ? `, ${reasonText}` : ''}`,
      ...data
    }

    try {
      const http = new DynamicAPI('v1');
      await http.get(
        '/IntegratedTracking/DisableOrEnablePhotoOccurrence',
        params,
      );

      setInactive();
      setSuccessRequest(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }
  
  return (
    <Modal
      title="Inativar imagem"
      size="small"
      hasClose={true}
      onBackdropClick={onBackdropClick}
      secondaryHeader={true}
    >
      {!successRequest ? (
        <Container>
          <Description>
            Atenção! Ao inativar a imagem, o usuário deixará de visualizá-la.
            Você poderá reativá-la quando desejar.
          </Description>

          <RadioGroup
            value={selectedRadio}
            onChangeValue={value => setSelectedRadio(value)}
          >
            <Radio
              value={reasonForInactivation.PHOTO_DOES_NOT_MATCH}
              label="Foto não corresponde à Nota Fiscal"
            />
            <Radio
              value={reasonForInactivation.PHOTO_IS_NOT_SHARP}
              label="Foto não está nítida"
            />
          </RadioGroup>
          {selectedRadio && (
            <TextField
              id="standard-basic"
              label="Justificativa"
              variant="standard"
              fullWidth
              placeholder="Digite uma justificativa*"
              maxlength={100}
              required={true}
              onChange={e => onChangeReasonTextField(e)}
            />
          )}
          <ButtonContainer>
            <ButtonCancel onClick={onBackdropClick}>Cancelar</ButtonCancel>
            <ButtonInactivate
              disabled={!selectedRadio || reasonText.length === 0 || loading}
              onClick={handleInactivate}
            >
              {loading ? <CircularProgress size={27.5} /> : 'Desativar'}
            </ButtonInactivate>
          </ButtonContainer>
        </Container>
      ) : (
        <Container>
          <SuccessText>
            <SuccessCircleIcon />
            Imagem inativada com sucesso.
          </SuccessText>
          <Description>
            O usuário não terá mais acesso a essa imagem. Você poderá reativá-la
            quando desejar.
          </Description>
        </Container>
      )}
    </Modal>
  );
};

export default InactivateReceiptStatusModal;
